"use client"

import { useState, ReactNode } from 'react'
import AppSidebar from './AppSidebar'
import Header from './Header'
import { HeaderSlotsProvider } from './PageHeader'
import { getStoredUser, getStoredValue } from '../../utils/service'

interface MainLayoutProps {
  children: ReactNode
  activeSection?: string
  setActiveSection?: (section: string) => void
}

const MainLayout = ({ children }: MainLayoutProps) => {
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false)

  const storedUser = getStoredUser()
  const user = {
    name: storedUser ? `${storedUser.first_name} ${storedUser.last_name}` : localStorage.getItem('name') || 'Sales Admin',
    email: storedUser?.email || getStoredValue('email') || 'sales@proapp.me',
    role: storedUser?.role || localStorage.getItem('role') || 'Sales Manager',
    initials: storedUser && storedUser.first_name && storedUser.last_name
      ? `${storedUser.first_name[0]}${storedUser.last_name[0]}`.toUpperCase()
      : (localStorage.getItem('name') || 'SA').split(' ').map(n => n[0]).join('').toUpperCase().slice(0, 2)
  }

  return (
    <HeaderSlotsProvider>
    <div className="min-h-screen w-full bg-primary/20 overflow-hidden">
      <style>{`
        .no-scrollbar::-webkit-scrollbar { display: none; }
        .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
      `}</style>

      <AppSidebar user={user} mobileOpen={mobileSidebarOpen} onCloseMobile={() => setMobileSidebarOpen(false)} />

      <div
        className="fixed top-3 right-3 bottom-3 z-50 flex flex-col bg-white rounded-2xl shadow-sm transition-[left] duration-200"
        style={{ left: 'calc(var(--sidebar-w, 0px) + 0.75rem)' }}
      >
        <Header user={user} onOpenMobileSidebar={() => setMobileSidebarOpen(true)} />
        <main className="flex-1 min-h-0 overflow-y-auto no-scrollbar rounded-b-2xl px-4 pb-4 sm:px-6 sm:pb-6 pt-2">
          {children}
        </main>
      </div>
    </div>
    </HeaderSlotsProvider>
  )
}

export default MainLayout
